const initialState = {
  avails: [],
  demographics: [],
  exchange: null,
  exchangeSettings: null,
  geofenceGroups: [],
  languages: [],
  lineItem: null,
  lineItems: [],
  locations: [],
  locationsExcluded: [],
  markets: [],
  mediaTypes: [],
  networks: [],
  organizationDSPs: [],
  package: null,
  packages: [],
  permissions: null,
  sites: [],
  sitesExcluded: [],
  suppliers: [],
  targetingCriteria: [],
  totalLineItems: 0,
  totalPackages: 0,
  units: [],
  unitsExcluded: [],
};

export default initialState;
